import NavigationLayout from "../../navigation/navigationLayout";
import FooterLayout from '../../footer/footerLayout';
import { Box, Stack, useTheme } from "@mui/material";
import DigitalServicesHero from '../digitalServicesHero';
import { useTranslation } from "react-i18next";
import SolutionsView from "../solutionsView";
import TechStackList from "../techStackList";
import projectsData from '../../../assets/data/projects.json';
import ProjectDetails from "../projectDetails";
import { useCallback, useEffect, useState } from "react";
import ButtonComponent from "../../../components/form/buttonComponent";
import GetQuote from "../../contactUs/getQuote";
import companyData from '../../../assets/data/company.json';

const key = "services.game";

const techStackList = [
    { src: "/images/tech-stack/Unity3D.png", alt: "Unity 3D" },
    { src: "/images/tech-stack/UnrealEngine.png", alt: "Unreal Engine" },
    { src: "/images/tech-stack/PixiJS.png", alt: "PixiJS" },
    { src: "/images/tech-stack/ThreeJS.png", alt: "Three.js" },
    { src: "/images/tech-stack/CSharp.png", alt: "C#" },
    { src: "/images/tech-stack/C++.png", alt: "C++" },
    { src: "/images/tech-stack/JavaScript.png", alt: "JavaScript" },
    { src: "/images/tech-stack/TypeScript.png", alt: "TypeScript" },
    { src: "/images/tech-stack/Python.png", alt: "Python" },
    { src: "/images/tech-stack/Xcode.png", alt: "Xcode" },
    { src: "/images/tech-stack/ARKit.png", alt: "ARKit" },
    { src: "/images/tech-stack/ARCore.png", alt: "ARCore" },
    { src: "/images/tech-stack/Vuforia.png", alt: "Vuforia" },
    { src: "/images/tech-stack/PhotonEngine.png", alt: "Photon Engine" },
    { src: "/images/tech-stack/Firebase.png", alt: "Firebase" },
    { src: "/images/tech-stack/Blender.png", alt: "Blender" },
    { src: "/images/tech-stack/AutodeskMaya.png", alt: "Autodesk Maya" },
    { src: "/images/tech-stack/Spine2D.png", alt: "Spine 2D" },
    { src: "/images/tech-stack/Audacity.png", alt: "Audacity" },
    { src: "/images/tech-stack/GoogleCloudPlatform.png", alt: "Google cloud platform" },
    { src: "/images/tech-stack/AWS.png", alt: "AWS" },
    { src: "/images/tech-stack/NodeJS.png", alt: "Node.js" },
    { src: "/images/tech-stack/SpringBoot.png", alt: "Spring Boot" },
    { src: "/images/tech-stack/MongoDB.png", alt: "MongoDB" },
    { src: "/images/tech-stack/PostgreSQL.png", alt: "PostgreSQL" },
    { src: "/images/tech-stack/SQLite.png", alt: "SQLite" },
    { src: "/images/tech-stack/UnityAds.png", alt: "Unity Ads" },
    { src: "/images/tech-stack/GoogleAdMob.png", alt: "Google AdMob" },
    { src: "/images/tech-stack/IronSource.png", alt: "IronSource" },
    { src: "/images/tech-stack/AppLovin.png", alt: "AppLovin" },
    { src: "/images/tech-stack/FacebookAudienceNetwork.png", alt: "Facebook audience network" },
    { src: "/images/tech-stack/Steam.png", alt: "Steam" },
    { src: "/images/tech-stack/EpicGamesStore.png", alt: "Epic Games Store" },
    { src: "/images/tech-stack/itchIO.png", alt: "itch.io" },
    { src: "/images/tech-stack/AppleAppStore.png", alt: "Apple App Store" },
    { src: "/images/tech-stack/GooglePlayStore.png", alt: "Google Play Store" },
    { src: "/images/tech-stack/HuaweiAppGallery.png", alt: "Huawei AppGallery" },
    { src: "/images/tech-stack/MetaQuestStore.png", alt: "Meta Quest Store" },
    { src: "/images/tech-stack/Git.png", alt: "Git" }
];

const GameServicesLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const solutionsList = [
        {title: t(`${key}.categories.1.label`), description: t(`${key}.categories.1.description`), icon: '/images/icons/mobile.svg'},
        {title: t(`${key}.categories.2.label`), description: t(`${key}.categories.2.description`), icon: '/images/icons/web.svg'},
        {title: t(`${key}.categories.3.label`), description: t(`${key}.categories.3.description`), icon: '/images/icons/games.svg'},
        {title: t(`${key}.categories.4.label`), description: t(`${key}.categories.4.description`), icon: '/images/icons/book.svg'},
        {title: t(`${key}.categories.5.label`), description: t(`${key}.categories.5.description`), icon: '/images/icons/network.svg'},
        {title: t(`${key}.categories.6.label`), description: t(`${key}.categories.6.description`), icon: '/images/icons/business.svg'},
        {title: t(`${key}.categories.7.label`), description: t(`${key}.categories.7.description`), icon: '/images/icons/vr.svg'},
        {title: t(`${key}.categories.8.label`), description: t(`${key}.categories.8.description`), icon: '/images/icons/setting.svg'}
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [getQuote, setGetQuote] = useState(false);
    
    const getAQuote = useCallback(() => {
        // setGetQuote(true);

        window.open(companyData.contact.formLinks.quotation, "_blank");
    }, []);

    return (
        <>
            <NavigationLayout />

            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <DigitalServicesHero 
                        banner='/images/services/game/gameBanner.png'
                        title={t(`${key}.title`)}
                        description={t(`${key}.description`)}
                        imageLgSize="75%"
                    />

                    <SolutionsView list={solutionsList}/>

                    <TechStackList list={techStackList}/>

                    <ProjectDetails 
                        list={projectsData.games}
                        mockupSize="75%"
                    />

                    <Stack
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        width='100%'
                    >
                        <ButtonComponent 
                            label={t('navigation.quote')}
                            onClick={getAQuote}
                            sx={{
                                animation: 'bounceButton 1s infinite'
                            }}
                        />
                    </Stack>
                </Stack>
            </Box>

            <GetQuote open={getQuote} setOpen={setGetQuote}/>

            <FooterLayout />
        </>
    );
}

export default GameServicesLayout;